import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatView = _resolveComponent("StatView")!
  const _component_SimilarGraph = _resolveComponent("SimilarGraph")!
  const _component_TableView = _resolveComponent("TableView")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.view == 'stat')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(_component_StatView, {
            results: _ctx.results,
            errorMsg: _ctx.errorMsg,
            loading: _ctx.loading
          }, null, 8, ["results", "errorMsg", "loading"])
        ]))
      : (_ctx.view == 'graph')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_SimilarGraph, {
              results: _ctx.results,
              errorMsg: _ctx.errorMsg,
              sql: _ctx.filteredSql,
              loading: _ctx.loading,
              sourceIds: _ctx.ids,
              emptyMessage: _ctx.emptyMessage
            }, null, 8, ["results", "errorMsg", "sql", "loading", "sourceIds", "emptyMessage"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_TableView, {
              results: _ctx.results,
              errorMsg: _ctx.errorMsg,
              sql: _ctx.filteredSql,
              loading: _ctx.loading,
              ids: _ctx.ids,
              emptyMessage: _ctx.emptyMessage
            }, null, 8, ["results", "errorMsg", "sql", "loading", "ids", "emptyMessage"])
          ]))
  ]))
}